<template>
  <div class="p-4">
    <ul>
      <li v-for="(filter, index) in filters[0].filters" :key="index" class="mb-2">
        <div v-if="!filter.filters" class="flex items-center gap-2">
          <Dropdown 
            v-model="filter.indexType"
            :options="indexTypeOptions"
            optionLabel="label"
            optionValue="value"
            class="dropdown-box leading-3"
            :disabled="editPageType"
            @change="updateOperator(filter)"
            placeholder="選擇主類型"
          />
          <Dropdown 
            v-model="filter.indexTypeSub"
            :options="indexTypeSubOptions"
            optionLabel="label"
            optionValue="value"
            class="dropdown-box leading-3"
            :disabled="filter.indexType === 'DAY' || editPageType == true"
            @change="updateOperator"
            placeholder="選擇子類型"
          />
          <Dropdown 
            v-model="filter.operator"
            :options="operatorOptions"
            optionLabel="label"
            optionValue="value"
            class="dropdown-box leading-3"
            :disabled="editPageType"
            @change="updateOperator"
            placeholder="選擇運算符"
          />
          <input v-model="filter.value" type="text" placeholder="值" class="input-box leading-7 w-40" :disabled="editPageType" @change="updateOperator"/>
          <button v-if="editPageType == false" @click="removeFilter(index)" class="btn btn-danger text-sm">🗑️</button>
        </div>

        <!-- 條件組（遞迴） -->
        <div v-else>
          <div class="items-center justify-between bg-gray-200 px-2 py-1 rounded h-11 text-right">
            <button @click="removeFilter(index)" class="btn btn-danger text-xs">刪除條件組</button>
          </div>

          <RuleRaiseGroup
            :filters="[filter]"
            v-bind:editPage="editPageType"
            @changeData="updateChildFilters(index, $event)"
            :canAddCondition="canAddCondition"
            class="rounded-b border-l-2 pl-4"
          />
        </div>

        <!-- 邏輯選擇器 -->
        <div v-if="index < filters[0].filters.length - 1" class="logic-selector my-2">
          <Dropdown 
            v-model="filters[0].operator"
            :options="logicOptions"
            optionLabel="label"
            optionValue="value"
            class="dropdown-box leading-3"
            :disabled="editPageType"
            @change="updateOperator"
            placeholder="選擇邏輯"
          />
        </div>
      </li>
    </ul>

    <div v-if="canAddCondition && editPageType == false">
      <button @click="addCondition" class="btn btn-primary">新增條件</button>
      <button @click="addGroup" class="btn btn-secondary ml-2">新增條件組</button>
    </div>
  </div>
</template>

<script>
import Dropdown from 'primevue/dropdown';

export default {
  name: "RuleRaiseGroup",
  components: {
    Dropdown,
  },
  props: {
    filters: Array, // 確保 filters 是一個陣列
    conditionCount: Number,
    canAddCondition: Boolean,
    editPage: {
      type: Boolean
    },
  },
  data() {
    return {
      indexTypeOptions: [
        { label: 'CPA', value: 'LIFETIME_CPA' },
        { label: 'ROAS', value: 'LIFETIME_ROAS' },
        { label: 'CTR', value: 'LIFETIME_CTR' },
        { label: '花費', value: 'LIFETIME_SPEND' },
        { label: '走期天數', value: 'DAY' },
        { label: '成果數', value: 'LIFETIME_ACTION' },
      ],
      indexTypeSubOptions: [
        { label: '近7天', value: '7D' },
        { label: '整個走期', value: 'LIFETIME' },
        { label: '兩周', value: '2X' },
      ],
      operatorOptions: [
        { label: '大於', value: 'GREATER_THAN' },
        { label: '大於等於', value: 'GREATER_THAN_EQUAL' },
        { label: '等於', value: 'EQUAL' },
        { label: '小於等於', value: 'LESS_THAN_EQUAL' },
        { label: '小於', value: 'LESS_THAN' },
      ],
      logicOptions: [
        { label: 'AND', value: 'AND' },
        { label: 'OR', value: 'OR' },
      ],
    }
  },
  methods: {
    // 新增條件
    addCondition() {
      if (!this.filters[0].filters) {
        this.filters[0].filters = [];
      }

      this.filters[0].filters.push({
        indexTypeSub: "",
        indexType: "",
        operator: "GREATER_THAN_EQUAL",
        value: null,
      });

      this.emitUpdate();
    },

    // 新增條件組
    addGroup() {
      if (!this.filters[0].filters) {
        this.filters[0].filters = [];
      }

      const newGroup = {
        operator: "AND",
        filters: []
      };

      this.filters[0].filters.push(newGroup);
      this.emitUpdate();
    },

    // 刪除條件
    removeFilter(index) {
      this.filters[0].filters.splice(index, 1);
      this.emitUpdate();
    },

    // 更新子組件的過濾器
    updateChildFilters(index, updatedFilters) {
      this.filters[0].filters[index] = updatedFilters[0]; 
      this.emitUpdate();
    },

    linkIndexTypeSub(filter) {
      const indexTypeSubMap = {
        DAY: "LIFETIME",
        LIFETIME_SPEND: "LIFETIME",
        LIFETIME_ACTION: "LIFETIME",
        LIFETIME_CPA: "7D",
        LIFETIME_ROAS: "7D",
        LIFETIME_CTR: "7D",
      };

      if (filter.indexType in indexTypeSubMap) {
        filter.indexTypeSub = indexTypeSubMap[filter.indexType];
      }

      // 禁用處理
      if (filter.indexType === "DAY") {
        filter.indexTypeSub = "LIFETIME";
      }
    },

    // 更新 operator 並發送變更
    updateOperator(filter) {
      this.linkIndexTypeSub(filter);

      this.$emit("changeData", [...this.filters]); // 傳遞整個陣列
    },

    // 發送更新事件到父組件
    emitUpdate() {
      this.$emit("changeData", [...this.filters]);
    },
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    }
  }
};
</script>

<style scoped>
.rule-group {
  @apply border border-gray-300 rounded-md p-4 bg-gray-50;
}

.input-box {
  @apply border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400;
}

.btn {
  @apply px-4 py-2 rounded text-white font-medium focus:outline-none transition;
}

.btn-primary {
  @apply bg-blue-500 hover:bg-blue-600;
}

.btn-secondary {
  @apply bg-gray-500 hover:bg-gray-600;
}

.btn-danger {
  @apply bg-red-500 hover:bg-red-600;
}

.dropdown-box {
  @apply w-40 border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400;
}
</style>
